import { Grid, Slider, Stack } from '@mui/material';

interface ImageScaleSliderProps {
  value: number;
  handleChange: (zoom: number) => void;
}

const ImageScaleSlider = ({ value, handleChange }: ImageScaleSliderProps) => (
  <Grid item sx={{ width: '100%' }}>
    画像の拡大率
    <Stack spacing={2} direction="row" sx={{ mb: 1 }} alignItems="center">
      小
      <Slider
        min={0.1}
        max={3}
        step={0.01}
        aria-label="Zoom"
        value={value}
        sx={{ mx: 2 }}
        onChange={(event, value) => handleChange(value as number)}
      />
      大
    </Stack>
  </Grid>
);

export default ImageScaleSlider;
